import './Share.scss'
import logo from '../../assets/logo.png'
import { Link, useLocation } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'

const appStore = 'https://apps.apple.com/kz/app/totem-chat/id6444722452'
const playStore = 'https://play.google.com/store/apps/details?id=kz.mobile.totemchat'
const shareKeys = ['appInvite', 'chat', 'post', 'postComment', 'event', 'eventCheckIn', 'friendRequest']

const Share = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const kind = shareKeys.find(key => params.get(key)?.trim())
  // Keep the complete query when opening or copying, including encoded IDs.
  const shareURL = `https://thetotemchat.com/share${search}`
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isInAppBrowser = /Instagram|FBAN|FBAV/i.test(navigator.userAgent)
  const openURL = isIOS
    ? `totemchat://share${search}`
    : `intent://thetotemchat.com/share${search}#Intent;scheme=https;package=kz.mobile.totemchat;S.browser_fallback_url=${encodeURIComponent(playStore)};end`
  const linkField = useRef(null)
  const [copyStatus, setCopyStatus] = useState('')

  useEffect(() => setCopyStatus(''), [search])

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareURL)
      setCopyStatus('Ссылка скопирована.')
    } catch {
      linkField.current?.focus()
      linkField.current?.select()
      setCopyStatus('Скопируйте выделенную ссылку через меню браузера.')
    }
  }

  return (
    <div className='share'>
      <header className='header share__header'>
        <Link to='/' aria-label='Главная Totem Chat'>
          <img src={logo} className='logo' alt='Totem Chat' />
        </Link>
      </header>
      <main className='share__content'>
        <h1>{kind === 'appInvite' ? 'Приглашение в Totem Chat' : 'Totem Chat'}</h1>
        {kind ? <>
          <p>Откройте ссылку на телефоне в приложении Totem Chat.</p>
          {(isIOS || isAndroid) && <a href={openURL} className='share__link'>Открыть Totem Chat</a>}
          {isInAppBrowser && <p>Если приложение не открывается, выберите в меню «Открыть в браузере» или скопируйте ссылку в Safari или Chrome.</p>}
          <p>Если Totem ещё не установлен, скачайте его, затем вернитесь к этому приглашению или сообщению и снова откройте ссылку.</p>
          <div className='share__stores'>
            <a href={appStore} target='_blank' rel='noreferrer'>Скачать в App Store</a>
            <a href={playStore} target='_blank' rel='noreferrer'>Скачать в Google Play</a>
          </div>
          {isIOS && <p>Если Totem установлен, но кнопка не срабатывает, обновите приложение или нажмите «Открыть» в баннере Safari.</p>}
          <label className='share__copy-label' htmlFor='share-url'>Ссылка для открытия на телефоне</label>
          <textarea ref={linkField} id='share-url' className='share__url' readOnly value={shareURL} rows={3} />
          <button className='share__link share__copy' type='button' onClick={copyLink}>Скопировать ссылку</button>
          <p className='share__status' role='status'>{copyStatus}</p>
        </> : <>
          <p role='alert'>В ссылке нет приглашения или публикации. Попросите отправителя прислать её ещё раз.</p>
          <Link to='/' className='share__link'>На главную</Link>
        </>}
      </main>
    </div>
  )
}

export default Share
